<template>
  <div class="case">
    <banner img="c_bg2.jpg" title="经典案例" />
    <div class="case-product">
      <div class="case-product-content">
        <!-- <img v-lazy="imgserver+caseIdList.Img" alt /> -->
        <img :src="require('../assets/case/'+caseIdList.Img)" alt="案例" />
      <div class="product-box">
        <p class="product-title">{{caseIdList.Title}}</p>
        <p class="product-time">{{caseIdList.CreateTime}}</p>
        <p class="product-content">{{caseIdList.Content}}</p>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  components: {
    Banner
  },
  data() {
    return {
      pid: 0,
      // caseIdList: {}
    };
  },
  created() {
    this.pid = this.$route.params.id;
    window.console.log(this.pid);
  },
  mounted() {
    this.loadData();
  },
  computed:{
    caseIdList:function(){
      console.log()
      return this.$store.state.caseAll.filter(v=>v.Id ==this.pid)[0]
    }
  },
  methods: {
    loadData() {
      // console.log(this.$store.state.caseAll.filter(v=>v.id ==this.pid))
      // this.caseIdList = this.$store.state.caseAll.filter(v=>v.id ==this.pid)[0]
      // this.$http
      //   .get(`Cases/GetCasesById/${this.pid}`)
      //   .then(response => {
      //     //console.log(response);
      //     this.caseIdList = response.data;
      //     window.console.log(this.caseIdList);
      //   })
      //   .catch(function(error) {
      //     window.console.log(error);
      //   });
    }
  }
};
</script>

<style lang="scss" scoped>
.case {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #fff;
  &-product {
    max-width: 1240px;
    margin: 0 auto;
    background-color: #fff;
    //border: 1px solid red;
    &-content {
      max-width: 760px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 50px 20px;
      img {
        width: 100%;
        max-height: 430px;
      }
      .product-box{
        .product-title {
          font-size: 25px;
          color: #e13834;
          padding: 20px 0;
        }
        .product-content {
          font-size: 17px;
          font-weight: bolder;
          padding: 20px 0;
          text-indent:2em;
          white-space: pre-wrap;
          line-height: 28px;

        }
      }
      
    }
  }
}
</style>